import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { IAuthCommon } from './../store/auth.interfaces';
import { LoginUser } from 'src/app/shared/models/login-user';
import { ResetPasswordUser } from 'src/app/shared/models/reset-password-user';

@Injectable({
    providedIn: 'root',
})
export class ApproverAuthService {
    constructor(private http: HttpClient) { }

    /**
     * Login in to Approver
     * @param loginUser {LoginUser}
     * @returns Observable<IAuthCommon>
     */
    approverLogin(loginUser: LoginUser): Observable<IAuthCommon> {
        return this.http
            .post<any>(`${environment.api.root}/${environment.api.auth_approver}/${environment.api.approver.approver_login}`, {
                data: { userName: loginUser.userName, password: loginUser.password },
            })
            .pipe(
                map((res) => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    /**
     * forgot password
     * @param username {string}
     * @returns Observable<string>
     */
    forgotPassword(username: string): Observable<string> {
        return this.http
            .post<any>(`${environment.api.root}/${environment.api.auth_approver}/${environment.api.approver.approver_forgot_password}`, {
                data: { username },
            })
            .pipe(
                map((res) => {
                    return res; // this isn't going to be consumed
                }),
                catchError(this.handleError)
            );
    }

    /**
     * Reset Password
     * @param resetPasswordUser {ResetPasswordUser}
     * @returns Observable<string>
     */
    resetPassword(resetPasswordUser: ResetPasswordUser): Observable<string> {
        return this.http
            .post<any>(`${environment.api.root}/${environment.api.auth_approver}/${environment.api.approver.approver_reset_password}`, {
                data: { currentPassword: resetPasswordUser.currentPassword, newPassword: resetPasswordUser.newPassword },
            })
            .pipe(
                map((res) => {
                    return res; // this isn't going to be consumed
                }),
                catchError(this.handleError)
            );
    }



    private handleError(err) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage: string;
        if (err && err.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Backend returned code ${err.status}: ${err.code}`;
            if (err.error) {
                errorMessage = err.error;
            }
        }
        return throwError(errorMessage);
    }

}
